import React from 'react';

const Support = () => {

  return (
    <div className="dashboard-body">
        <h1>SUPPORT</h1>
        <p>New features coming soon!</p>
        <p>If you require assistance or are experiencing errors, please <a href="mailto:hello@mpoweringsolutions.co.uk" className="clickable-link">send us an email</a> and we will get in touch within 48 hours.</p>
    </div>
  )
}

export default Support